export default __webpack_public_path__ + "static/race-desktop-187dfae7746432be665518586f006ba6.mp4";